/**
 * The hospitality vertical's sidebar entry.
 *
 * `packOnly` keeps it out of the `ventes-caisse` group grant: that group is
 * held by every profile, so without the marker a boutique would render a
 * floor plan. Anchored after the till, which is the screen it leads into.
 */
import { BedDouble, BookOpen, ChefHat, LayoutGrid, LogIn, TrendingUp } from 'lucide-react';
import type { NavContribution } from '../types';

export const hospitaliteNav: readonly NavContribution[] = [
  {
    intoGroup: 'ventes-caisse',
    after: 'pos',
    items: [
      {
        key: 'tables',
        href: '/plan-de-salle',
        icon: LayoutGrid,
        labelKey: 'nav.tables',
        permission: 'invoices:create',
        planFeature: 'pos',
        packOnly: true,
        surface: 'POS',
      },
      {
        key: 'menu',
        href: '/carte',
        icon: BookOpen,
        labelKey: 'nav.menu',
        permission: 'invoices:create',
        planFeature: 'pos',
        packOnly: true,
        surface: 'POS',
      },
      {
        key: 'stations',
        href: '/postes',
        icon: ChefHat,
        labelKey: 'nav.stations',
        permission: 'invoices:create',
        planFeature: 'pos',
        packOnly: true,
        surface: 'POS',
      },
    ],
  },
  // Lodging, anchored after the restaurant screens: the folio is the same
  // POS transaction a table holds, so the two sets belong side by side.
  {
    intoGroup: 'ventes-caisse',
    after: 'stations',
    items: [
      {
        key: 'rooms',
        href: '/chambres',
        icon: BedDouble,
        labelKey: 'nav.rooms',
        permission: 'invoices:create',
        planFeature: 'pos',
        packOnly: true,
        surface: 'POS',
      },
      {
        key: 'stays',
        href: '/sejours',
        icon: LogIn,
        labelKey: 'nav.stays',
        permission: 'invoices:create',
        planFeature: 'pos',
        packOnly: true,
        surface: 'POS',
      },
      {
        key: 'indicators',
        href: '/indicateurs',
        icon: TrendingUp,
        labelKey: 'nav.indicators',
        // Management reporting, not the floor: DG and VIEWER hold this, a
        // waiter opening tables does not.
        permission: 'reports:sales',
        planFeature: 'pos',
        packOnly: true,
      },
    ],
  },
];
